import { m } from '@aimfora/i18n'
import type { CookieConsentConfig } from 'vanilla-cookieconsent'

/** The purposes the visitor can switch on or off. `necessary` is always on. */
export const CONSENT_CATEGORIES = ['necessary', 'analytics'] as const

/**
 * The banner and the preferences dialog, all in Danish from the message catalog. "Afvis alle" and
 * "Acceptér alle" carry the same weight, as the rules for consent ask. `onAnalytics` hears the
 * choice on every page load (from the stored choice) and whenever it changes.
 */
export function buildConsentConfig(onAnalytics: (granted: boolean) => void): CookieConsentConfig {
  const report = ({ cookie }: { cookie: { categories: string[] } }) =>
    onAnalytics(cookie.categories.includes('analytics'))

  return {
    revision: 0,
    cookie: { name: 'cc_cookie', expiresAfterDays: 182 },
    guiOptions: {
      consentModal: { layout: 'box', position: 'bottom right', equalWeightButtons: true },
      preferencesModal: { layout: 'box', equalWeightButtons: true },
    },
    categories: {
      necessary: { enabled: true, readOnly: true },
      analytics: {},
    },
    language: {
      default: 'da',
      translations: {
        da: {
          consentModal: {
            title: m.consent_banner_title(),
            description: m.consent_banner_description(),
            acceptAllBtn: m.consent_accept_all(),
            acceptNecessaryBtn: m.consent_reject_all(),
            showPreferencesBtn: m.consent_show_preferences(),
          },
          preferencesModal: {
            title: m.consent_prefs_title(),
            acceptAllBtn: m.consent_accept_all(),
            acceptNecessaryBtn: m.consent_reject_all(),
            savePreferencesBtn: m.consent_save(),
            closeIconLabel: m.consent_close(),
            sections: [
              {
                title: m.consent_necessary_title(),
                description: m.consent_necessary_description(),
                linkedCategory: 'necessary',
              },
              {
                title: m.consent_analytics_title(),
                description: m.consent_analytics_description(),
                linkedCategory: 'analytics',
              },
              {
                title: m.consent_more_title(),
                description: m.consent_more_description(),
              },
            ],
          },
        },
      },
    },
    onConsent: report,
    onChange: report,
  }
}
